import { render, staticRenderFns } from "./StdCommDiscFactors.vue?vue&type=template&id=373297e0&"
import script from "./StdCommDiscFactors.vue?vue&type=script&lang=js&"
export * from "./StdCommDiscFactors.vue?vue&type=script&lang=js&"
import style0 from "./StdCommDiscFactors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdCommDiscFactors.vue"
export default component.exports